import React, { Component } from 'react';

import { FormattedHTMLMessage } from 'react-intl';
import { Row, Col, Checkbox } from 'react-bootstrap';
import Whatsapp from './WhatsappButton.js';

import FullScreenTemplate from './FullScreenTemplate.js';

import BasicTemplate from './BasicTemplate.js';


class GreetingsModal extends Component {

    constructor(props){
        super(props);
        this.state = {
            greetings: false,
        };

        this.showGreetings = this.showGreetings.bind(this);
    }

    showGreetings(event) {
        event.preventDefault();
        this.setState({
            greetings: true
        });
    }


    render() {
        const { greetings } = this.state;

        const greetingsButton = (
        <div className="col-sm-12 col-md-12 col-lg-12 text-center">
            <button  className="btn btn-warning btn-lg pd-button pd-form" onClick={this.showGreetings}>Continuar</button>
        </div>
        );

        const modal = (
            <FullScreenTemplate>
                <BasicTemplate>
                    <Row><Col><FormattedHTMLMessage id="app.greetings_modal" description=" "/></Col></Row>
                    <Whatsapp phone={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_number", defaultMessage: "542612554220"})}
                                  text={this.context.intl.formatMessage({
                                      id:"app.step_sms_whatsapp_text", defaultMessage: "Tengo+una+consulta"})}
                                  value={this.context.intl.formatMessage({
                                      id:"app.step_sms_whatsapp_label", defaultMessage: "261-2554-220"})}
                                  gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping"/>
                </BasicTemplate>
            </FullScreenTemplate>
        );

        return greetings ? modal : greetingsButton;
    }
}

GreetingsModal.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

export default GreetingsModal;


/** WEBPACK FOOTER **
 ** ./src/components/GreetingsModal.js
 **/